import { useCallback } from 'react'
import { ImagePickerResponse, launchCamera, launchImageLibrary } from 'react-native-image-picker'

export const useImagePicker = (setImage: (uri: string) => void) => {
  const handleImagePickerResponse = useCallback(
    (response: ImagePickerResponse) => {
      if (response.didCancel) {
        console.log('User cancelled image picker')
      } else if (response.errorCode) {
        console.log('ImagePicker Error: ', response.errorMessage)
      } else if (response?.assets?.[0].uri) {
        setImage(response.assets[0].uri)
      }
    },
    [setImage],
  )

  const openCamera = async () => {
    await launchCamera(
      { mediaType: 'photo', presentationStyle: 'fullScreen' },
      handleImagePickerResponse,
    )
  }

  const openImageLibrary = async () => {
    await launchImageLibrary(
      { mediaType: 'photo', presentationStyle: 'fullScreen' },
      handleImagePickerResponse,
    )
  }

  return { openCamera, openImageLibrary }
}

/**
 * Opens the image library with multi-select enabled using expo-image-picker.
 * Resolves with an array of selected URIs, or an empty array if cancelled.
 */
export const openImageLibraryMultiple = async (): Promise<string[]> => {
  const { launchImageLibraryAsync, MediaTypeOptions, requestMediaLibraryPermissionsAsync } = await import('expo-image-picker')

  const { granted } = await requestMediaLibraryPermissionsAsync()
  if (!granted) return []

  const result = await launchImageLibraryAsync({
    mediaTypes: MediaTypeOptions.Images,
    allowsMultipleSelection: true,
    quality: 1,
  })

  if (result.canceled) return []
  return result.assets.map((a) => a.uri)
}
